import client from './main-client';

export const getServiceApi = ({ id, ...params }) => client().get(`/services/${id}`, { params });
export const getServicesApi = (params) => client().get('/services', { params });
export const addNewServiceApi = (data) => client().post('/services', data);
export const deleteServicesApi = (params) => client().delete(`/services/${params.id}`, { params });
export const updateServiceApi = (params) => client().put(`/services/${params.id}`, params.values);
